export enum LocalePrefix {
    AsNeeded = 'as-needed',
    Always = 'always',
    Disabled = 'never',
}
